import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import logo from '../components/logo.png';
import { features } from '../config/features';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">Technology leaders building America</h1>
            <p className="hero-subtitle">Join the premier professional organization dedicated to fostering innovation, collaboration, and excellence in software engineering across the United States.</p>
            <div className="hero-buttons">
              {features.donate && <Link to="/donate" className="btn btn-primary">Donate</Link>}
              <Link to="/about" className="btn btn-secondary">Learn More</Link>
            </div>
          </div>
          <div className="hero-image">
            <img src={logo} alt="US Society of Software Engineers Logo" className="hero-logo" />
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about">
        <div className="container">
          <h2 className="section-title">About Us</h2>
          <div className="about-content">
            <div className="about-text">
              <p>The US Society of Software Engineers is a leading professional organization committed to advancing the field of software engineering through education, networking, and advocacy.</p>
              <p>Founded in 2024, we bring together software engineers, developers, architects, and technology leaders from across the United States to share knowledge, best practices, and drive innovation in our industry.</p>
            </div>
            <div className="about-image">
              <div className="image-placeholder">
                <i className="fas fa-users"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Articles */}
      <section className="featured-articles">
        <div className="container">
          <h2 className="section-title">Latest Articles</h2>
          <div className="articles-grid">
            <div className="article-card">
              <div className="article-image">
                <i className="fas fa-microchip"></i>
              </div>
              <div className="article-content">
                <div className="article-meta">
                  <span><i className="fas fa-calendar"></i>H1B visa reform for Engineers</span>
                  <span><i className="fas fa-user"></i> US Society of Software Engineers</span>
                </div>
                <h3></h3>
                <p className="article-excerpt">Examining how the legal immigration system is broken and how we can fix it.</p>
                <div className="article-tags">
                  <span className="article-tag"></span>
                  <span className="article-tag"></span>
                </div>
                <Link to="/articles" className="btn btn-outline">Click to Read</Link>
              </div>
            </div>
            <div className="article-card">
              <div className="article-image">
                <i className="fas fa-microchip"></i>
              </div>
              <div className="article-content">
                <div className="article-meta">
                  <span><i className="fas fa-calendar"></i>The $9-an-Hour Software That Killed 346 People</span>
                  <span><i className="fas fa-user"></i> US Society of Software Engineers</span>
                </div>
                <h3></h3>
                <p className="article-excerpt">How Boeing's use of cheap labor caused two massive plane crashes.</p>
                <div className="article-tags">
                  <span className="article-tag"></span>
                  <span className="article-tag"></span>
                </div>
                <Link to="/articles" className="btn btn-outline">Click to Read</Link>
              </div>
            </div>
          </div>
          <div className="text-center">
            <Link to="/articles" className="btn btn-primary">View All Articles</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 